import { Component, inject, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { OpenPageComponent } from '../../icons/open-page/open-page.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SearchResult } from '../../../../shared/models/internal/search-result';
import { EscapeKeyDirectiveDirective } from '../../../directives/escape-key-directive.directive';
import { PreselectionService } from '../../../services/preselection.service';

@Component({
  selector: 'app-search-result-list',
  imports: [OpenPageComponent, CommonModule, RouterModule, EscapeKeyDirectiveDirective],
  templateUrl: './search-result-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './search-result-list.component.scss',
})
export class SearchResultListComponent implements OnChanges {
  @Input() public searchResults: SearchResult[] = [];
  @Input() public invalidSearchTerm = false;
  public noResults = false;

  private preselectionService = inject(PreselectionService);

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['searchResults']) {
      const currentValue = changes['searchResults'].currentValue;
      const previousValue = changes['searchResults'].previousValue;

      if (
        (currentValue?.length === 0 && previousValue?.length === 0) ||
        (currentValue?.length === 0 && previousValue?.length > 0)
      ) {
        this.noResults = true;
      } else {
        this.noResults = false;
      }
    }

    if (changes['invalidSearchTerm']) {
      this.noResults = false;
    }
  }

  public navigateToSearchResult(searchResult: SearchResult | undefined): void {
    if (!searchResult || !searchResult.id || !searchResult.itemType) {
      return;
    }
    this.preselectionService.configureAndChangeRoute(searchResult.id, searchResult.title ?? '', searchResult.itemType);
  }

  public onEscape(): void {
    this.searchResults = [];
    this.noResults = false;
  }
}
